import Grid from "@mui/material/Grid2";
import React from "react";

import documentPreview from "@/assets/noAvailablepreview/document.png";
import sheetsPreview from "@/assets/noAvailablepreview/sheets.png";
import textPreview from "@/assets/noAvailablepreview/text.png";
import MDTypography from "@/components/atoms/MDTypography";
import { formatBytes } from "@/helpers/file-helpers";
import { CurrentChatMessages } from "@/messages/chat/current-chat.messages";
import { FileTypes } from "@/types/files.types";

interface DocumentPreviewProps {
  messages: CurrentChatMessages;
  file: File;
  type: FileTypes;
}

const DocumentPreview: React.FC<DocumentPreviewProps> = ({ messages, file, type }) => {
  const { noPreviewAvailable } = messages;

  return (
    <Grid style={{ textAlign: "center" }}>
      {type === FileTypes.TEXT && (
        <img src={textPreview} alt="Text Preview" width={88} height={110} />
      )}
      {type === FileTypes.SHEET && (
        <img src={sheetsPreview} alt="Text Preview" width={88} height={110} />
      )}
      {type !== FileTypes.TEXT && type !== FileTypes.SHEET && (
        <img src={documentPreview} alt="Text Preview" width={88} height={110} />
      )}
      <Grid
        size={{
          md: 12,
        }}
      >
        <MDTypography variant="h5" gutterBottom>
          {noPreviewAvailable}
        </MDTypography>
        <MDTypography variant="body2" gutterBottom>
          ({formatBytes(file.size)}) - {file.type}
        </MDTypography>
      </Grid>
    </Grid>
  );
};

export default DocumentPreview;
